export enum EELSMeetingsTabsUrl {
  TOPICS = 'topics',
  NOTES = 'notes',
  ATTENDEES = 'attendees',
  TA_TIME = 'ta-time',
  ACTION_ITEMS = 'action-items',
  THINGS_TO_SHARE = 'things-to-share',
}
